import { Children } from 'react';
import styled from 'styled-components';
import UIFlex from 'UIComponents/layout/UIFlex';
import { jsx as _jsx } from "react/jsx-runtime";
const CONTENT_CARD_MARGIN = 16;
const FlexChild = styled.div.withConfig({
  displayName: "ContentCardsRow__FlexChild",
  componentId: "pp5cyb-0"
})(["flex-basis:calc( ", "% - ", "px );flex-grow:1;margin:", "px;"], ({
  childCount
}) => Math.floor(100 / childCount), CONTENT_CARD_MARGIN * 2, CONTENT_CARD_MARGIN);

/**
 * **Deprecated**. Module and styles extracted from the existing CMS site — the
 * "old" styles. See
 * [the new Guides page](https://local.hubteamqa.com/docs-public/doc/cms/guides),
 * extracted from [the current live site](https://developers.hubspot.com/docs/cms/guides),
 * for an example.
 *
 * Eventually all cards will be migrated to the new card component, so please
 * use that for UX consistency instead.
 *
 * @deprecated
 *
 */
const ContentCardsRow = ({
  children
}) => {
  const childCount = Children.toArray(children).length;
  const contentCards = Children.map(children, child => /*#__PURE__*/_jsx(FlexChild, {
    childCount: childCount,
    children: child
  }));
  return /*#__PURE__*/_jsx(UIFlex, {
    align: "stretch",
    wrap: "wrap",
    children: contentCards
  });
};
export default ContentCardsRow;